import App from './app';

import {events, user, alerts} from './controllers'


export const core = App.Core({
    events,
    user,
    alerts,
})
export type ICore = typeof core;